import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UI, UIStateType } from './types';

const uiInitialState: UIStateType = {
  isDarkMode: true,
};

export const uiSlice = createSlice({
  name: UI,
  initialState: uiInitialState,
  reducers: {
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode;
    },
    darkModeConfirmed: (state, action: PayloadAction<{ isDarkMode: boolean }>) => {
      // Ensure UI state matches player confirmation
      state.isDarkMode = action.payload.isDarkMode;
    },
  },
});

export const { toggleDarkMode, darkModeConfirmed } = uiSlice.actions;
export default uiSlice.reducer;
